<template>
  <div class="container-top mt-5">
    <div class="d-flex flex-column flex-sm-row justify-content-sm-between">
      <div>
        <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
          Assets Management
        </div>
        <div class="d-flex align-items-center w-100 cursor-pointer">
          <span class="mr-1 text-white">
            <VideoPlayIcon />
          </span>
          <span class="s-13 text-dak font-weight-600">
            <u>
              {{
                navigatorLang === "en-US"
                  ? "Watch Video"
                  : $t("people.watchVideo")
              }}
            </u>
          </span>
        </div>
      </div>
      <div class="d-flex flex-wrap flex-sm-nowrap mt-3 mt-sm-0">
        <el-dropdown
          trigger="click"
          class="align-items-center w-100 justify-content-center d-flex ml-md-3 ml-0 default-btn2 py-0 m-0 border"
          style="height: 2.2rem"
        >
          <span
            class="el-dropdown-link w-100 primary--text d-flex align-items-center justify-content-center text-center font-weight-600"
          >
            <span>{{
              navigatorLang === "en-US" ? "More" : $t("people.more")
            }}</span>
            <el-icon class="el-icon--right">
              <arrow-down />
            </el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item class="text-dak">
                <router-link
                  :to="`/tenant/asset/all-assets`"
                  class="no-decoration text-dak w-100"
                >
                  Assets
                </router-link>
              </el-dropdown-item>
              <el-dropdown-item class="text-dak">
                <router-link
                  :to="`/tenant/asset/assetissues`"
                  class="no-decoration text-dak w-100"
                >
                  Issues
                </router-link>
              </el-dropdown-item>
              <el-dropdown-item class="text-dak w-100">
                <router-link
                  :to="`/tenant/asset/assetrequests`"
                  class="no-decoration text-dak"
                >
                  Requests
                </router-link>
              </el-dropdown-item>
              <el-dropdown-item class="text-dak w-100">
                <router-link
                  :to="`/tenant/asset/assetmaintenancehistory`"
                  class="no-decoration text-dak"
                >
                  Maintenance
                </router-link>
              </el-dropdown-item>

              <el-dropdown-item class="text-dak w-100">
                <router-link
                  :to="`/tenant/asset/assetcategories`"
                  class="no-decoration text-dak"
                >
                  Categories
                </router-link>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <router-link :to="`/tenant/asset/create`" class="no-decoration w-100">
          <el-button
            :color="primarycolor"
            class="ml-0 ml-sm-2 mt-sm-0 mt-3 w-100 header-btn"
            round
          >
            Add New Asset
          </el-button>
        </router-link>
      </div>
    </div>
    <div class="container-fluid px-0">
      <DashboardSummary
        :assetData="assets"
        :assetsRequestData="assetsRequest"
        :assetIssuesData="assetIssues"
      />
    </div>
    <div class="row mt-2">
      <div class="col-md-12 d-none d-md-block mt-3">
        <div
          class="col-md-12 px-3 py-4"
          style="background: #f8f8f8; border-radius: 15px"
        >
          <div class="row justify-content-center">
            <div
              class="text-head col-md-12 px-4 font-weight-bold"
              style="font-size: 18px"
            >
              {{
                navigatorLang === "en-US"
                  ? "Quick Things you can do"
                  : $t("dashboard.quickThings.text-head")
              }}
            </div>
          </div>
          <div class="row mt-2 justify-content-center">
            <div
              class="col-md-12 px-4 d-flex justify-content-between flex-wrap"
            >
              <div>
                <div class="quick-btn-link" @click="routeToAddAsset">
                  <el-button link>
                    Add Asset
                    <PlusCircleIcon class="w-12 h-12 primary--text ml-1" />
                  </el-button>
                </div>
              </div>
              <div>
                <div @click="routeToReportIssue" class="quick-btn-link">
                  <el-button link>
                    Report Issues
                    <WarningDiamondIcon class="w-12 h-12 primary--text ml-1"
                  /></el-button>
                </div>
              </div>
              <div>
                <div class="quick-btn-link">
                  <el-button size="large" link @click="routeToRequestAsset">
                    Request Asset
                    <HandCoinIcon class="w-12 h-12 primary--text ml-1" />
                  </el-button>
                </div>
              </div>
              <div>
                <div class="quick-btn-link">
                  <el-button link @click="routeaToAddMaintenance">
                    Add Maintenance
                    <PlusCircleIcon class="w-12 h-12 primary--text ml-1" />
                  </el-button>
                </div>
              </div>
              <div>
                <div class="quick-btn-link">
                  <el-button link @click="routeaToAddCategories">
                    Add Category
                    <StackPlusIcon class="w-12 h-12 primary--text ml-1" />
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 d-block d-md-none mt-3">
        <div
          class="col-md-12 px-3 py-4"
          style="background: #f8f8f8; border-radius: 15px"
        >
          <div class="d-flex">
            <span
              ><img class="w-100" src="../../../assets/quickaction.png" alt=""
            /></span>
            <span class="text-head text-dak s-20 mt-1 font-weight-600">
              {{
                navigatorLang === "en-US"
                  ? "Quick Things you can do"
                  : $t("dashboard.quickThings.text-head")
              }}
            </span>
          </div>
          <div class="mt-3">
            <div
              class="quick-btn-link font-weight-500 s-18 text-decoration-none primary--text"
              @click="routeToAddAsset"
            >
              <el-button link>
                Add Asset
                <PlusCircleIcon class="w-12 h-12 primary--text ml-1" />
              </el-button>
              <hr class="w-100" />
            </div>
          </div>
          <div class="mt-3">
            <div
              @click="routeToReportIssue"
              class="quick-btn-link font-weight-500 s-18 text-decoration-none primary--text"
            >
              <el-button link>
                Report Issues
                <WarningDiamondIcon class="w-12 h-12 primary--text ml-1"
              /></el-button>
              <hr class="w-100" />
            </div>
          </div>
          <div class="mt-3">
            <div
              class="quick-btn-link font-weight-500 s-18 text-decoration-none primary--text"
            >
              <el-button size="large" link @click="routeToRequestAsset">
                Request Asset
                <HandCoinIcon class="w-12 h-12 primary--text ml-1" />
              </el-button>

              <hr class="w-100" />
            </div>
          </div>
          <div class="mt-3">
            <div
              class="quick-btn-link font-weight-500 s-18 text-decoration-none primary--text"
            >
              <el-button link @click="routeaToAddMaintenance">
                Add Maintenance
                <PlusCircleIcon class="w-12 h-12 primary--text ml-1" />
              </el-button>
              <hr class="w-100" />
            </div>
          </div>
          <div class="mt-3">
            <div
              class="quick-btn-link font-weight-500 s-18 text-decoration-none primary--text"
            >
              <el-button link @click="routeaToAddCategories">
                Add Category
                <StackPlusIcon class="w-12 h-12 primary--text ml-1" />
              </el-button>
              <hr class="w-100" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid px-0">
      <div class="row">
        <div class="col-md-3 col-8"></div>
        <div class="col-md-9 col-12 mt-3">
          <div class="row">
            <div class="col-md-12 mt-4">
              <div
                v-if="
                  filteredMaintenanceData && filteredMaintenanceData.length > 0
                "
              >
                <div class="celeb-header d-flex align-items-center">
                  <div class="celeb-icon" style="height: 0% !important">
                    <span class="p-2 rounded-circle bg-blue-400 ml-4 mr-3">
                      <BroomIcon class="primary--text h-14 w-14" />
                    </span>
                  </div>
                  <div class="font-weight-600 text-head text-black s-32">
                    {{ maintenanceTextHead }}
                  </div>
                </div>
                <Table
                  :data="filteredMaintenanceData"
                  :headers="AssetMaintHeaders"
                  class="mt-3"
                  :checkMultipleItem="false"
                >
                  <template #scheduledDate="{ item }">
                    <div
                      class="c-pointer"
                      @click="routeaToAddMaintenance(item)"
                    >
                      {{ date(item.scheduledDate) }}
                    </div>
                  </template>
                  <template #assetCode="{ item }">
                    <div class="c-pointer" @click="routeToAssets(item)">
                      {{ item && item.asset ? item.asset.assetCode : "" }}
                    </div>
                  </template>

                  <template v-slot:name="{ item }">
                    <div class="c-pointer" @click="routeToAssets(item)">
                      {{ item && item.asset ? item.asset.name : "" }}
                    </div>
                  </template>
                  <template #category="{ item }">
                    <div
                      class="c-pointer"
                      @click="routeaToAddMaintenance(item)"
                    >
                      {{ item && item.asset ? item.asset.category : "" }}
                    </div>
                  </template>

                  <template v-slot:maintenanceDate="{ item }">
                    <div
                      class="c-pointer"
                      @click="routeaToAddMaintenance(item)"
                    >
                      {{ date(item.maintenanceDate) }}
                    </div>
                  </template>
                  <template v-slot:status="{ item }">
                    <div
                      class="c-pointer"
                      @click="routeaToAddMaintenance(item)"
                    >
                      {{ maintenanceStatus[item.status] }}
                    </div>
                  </template>
                  <template v-slot:action="{ item }">
                    <el-dropdown trigger="click">
                      <el-icon>
                        <MoreFilled />
                      </el-icon>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <!-- <el-dropdown-item
                            @click.prevent="editMaintenance(item)"
                          >
                            Edit
                          </el-dropdown-item> -->
                          <el-dropdown-item
                            @click.prevent="deleteMaintenance(item.id)"
                          >
                            Delete
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </template>
                </Table>
              </div>
            </div>
          </div>
          <div class="row mt-5">
            <div
              class="col-md-12"
              v-if="assetStatus.length > 0 || assetValueCategory.length > 0"
            >
              <div class="celeb-header d-flex align-items-center">
                <div class="celeb-icon" style="height: 0% !important">
                  <span class="p-2 rounded-circle bg-blue-400 ml-4 mr-3">
                    <CircleFourIcon class="primary--text h-14 w-14" />
                  </span>
                </div>
                <div class="font-weight-600 text-head text-black s-32">
                  Assets Distribution
                </div>
              </div>
            </div>
            <div class="col-md-6 mt-4">
              <!-- <div class="font-weight-bold text-center">Asset Status</div> -->
              <AnalyticsPieChart
                domId="assetStatus"
                :titleMargin="10"
                :summary="assetStatus"
              />
            </div>
            <!-- <div class="col-md-4">
          <div class="font-weight-bold text-center">
            Asset Count by Category
          </div>
          <AnalyticsPieChart
            domId="assetCountCategory"
            :titleMargin="10"
            :summary="assetCountCategory"
          />
        </div> -->
            <div class="col-md-6 mt-4">
              <AnalyticsPieChart
                domId="assetValueCategory"
                :titleMargin="10"
                :summary="assetValueCategory"
              />
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-md-12" v-if="assetCategoryColChart.length > 0">
              <div class="celeb-header d-flex align-items-center">
                <div class="celeb-icon" style="height: 0% !important">
                  <span class="p-2 rounded-circle bg-blue-400 ml-4 mr-3">
                    <ListBulletsIcon class="primary--text h-14 w-14" />
                  </span>
                </div>
                <div class="font-weight-600 text-head text-black s-32">
                  Assets Categorisation
                </div>
              </div>
            </div>
            <div class="col-md-12 mt-5">
              <AnalyticsColumnChart
                domId="column2"
                :columndata="assetCategoryColChart"
                :xAxisData="columnSeries ? columnSeries : []"
              />
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-md-12" v-if="assetIssueColChart.length > 0">
              <div class="celeb-header d-flex align-items-center">
                <div class="celeb-icon" style="height: 0% !important">
                  <span class="p-2 rounded-circle bg-blue-400 ml-4 mr-3">
                    <WarningDiamondIcon class="primary--text h-14 w-14" />
                  </span>
                </div>
                <div class="font-weight-600 text-head text-black s-32">
                  Assets Issues Trend
                </div>
              </div>
            </div>
            <div class="col-md-12 mt-5">
              <AnalyticsColumnChart
                domId="column1"
                :columndata="assetIssueColChart"
                :xAxisData="columnSeries ? columnSeries : []"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, inject, onMounted, computed } from "vue";
import { ElMessageBox, ElNotification } from "element-plus";
import AnalyticsPieChart from "@/components/charts/AnalyticsPieChart2";
import AnalyticsColumnChart from "@/components/charts/AnalyticsColumnChart.vue";
// import TableNoExport2 from "../../../components/table/TableNoExport2.vue";
import Table from "@/components/table/Table";
import DashboardSummary from "./DashboardSummary.vue";
import VideoPlayIcon from "../../../components/svg/VideoPlayIcon.vue";
import deviceBreakpoint from "../../../mixins/deviceBreakpoint";
import assetService from "../../../services/asset/assetServices";
import monthDayYear from "../../../services/dates/dateformatter";
import router from "../../../router/index";
import PlusCircleIcon from "../../../components/icons/PlusCircleIcon.vue";
import HandCoinIcon from "../../../components/icons/HandCoinIcon.vue";
import ListBulletsIcon from "../../../components/icons/ListBulletsIcon.vue";
import WarningDiamondIcon from "../../../components/icons/WarningDiamondIcon.vue";
import StackPlusIcon from "../../../components/icons/StackPlusIcon.vue";
import CircleFourIcon from "../../../components/icons/CircleFourIcon.vue";
import BroomIcon from "../../../components/icons/BrownIcon.vue";

const primarycolor = inject("primarycolor");
const navigatorLang = ref(navigator.language);
const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();
const maintenanceTextHead = ref("Upcoming Maintenance");
const searchText = ref("");
const showFilter = ref(false);
const loadingMaintenance = ref(false);
const assets = ref([]);
const assetsRequest = ref([]);
const assetIssues = ref([]);
const maintenanceData = ref([]);
const searchMaintenanceText = ref("");

const columnSeries = ref(["1", "2", "3", "4", "6", "7", "8"]);

const assetCategoryCol = ref([]);
const assetIssueTrendCol = ref([]);
const assetStatus = ref([]);
const assetValueCategory = ref([]);

const maintenanceStatus = ["Scheduled", "InProgress", "Completed", "Cancelled"];

const AssetMaintHeaders = ref([
  { name: "DUE DATE", value: "scheduledDate" },
  { name: "CODE", value: "assetCode" },
  { name: "ASSET NAME", value: "name" },
  { name: "ASEET CATEGORY", value: "category" },
  { name: "LAST SERVICE DATE", value: "maintenanceDate" },
  { name: "STATUS", value: "status" },
  { name: "ACTION", value: "action" },
]);

const routeToAssets = () => {
  router.push("/tenant/asset/all-assets");
};
const routeToAddAsset = () => {
  router.push("/tenant/asset/create");
};
const routeToReportIssue = () => {
  router.push("/tenant/asset/assetissues");
};
const routeaToAddMaintenance = () => {
  router.push("/tenant/asset/assetmaintenancehistory");
};
const routeaToAddCategories = () => {
  router.push("/tenant/asset/assetcategories");
};
const routeToRequestAsset = () => {
  router.push("/tenant/asset/assetrequests");
};

const getAssetCharts = async () => {
  try {
    const res = await assetService.getAssetCharts();
    console.log(res, 'kjsjd');
    if (res) {
    assetStatus.value = res.assetByStatus;
    assetValueCategory.value = res.assetByValue;
    assetIssueTrendCol.value = [res.issuesTrend];
    assetCategoryCol.value = [res.assetByCategory];
  }
    
  } catch (error) {
    console.log(error);
    
  }
}






const fetchCategoryTrend = async () => {
  const res = await assetService.getCategoryTrend();
  if (res) {
    assetCategoryCol.value = [res];
  }
};

const filteredMaintenanceData = computed(() => {
  if (!searchMaintenanceText.value.trim()) return maintenanceData.value;
  return maintenanceData.value.filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(searchMaintenanceText.value.toLowerCase())
  );
});
const seedCategory = async () => {
  try {
    await assetService.seedCategory();
  } catch (error) {
    console.log(error);
  }
};

onMounted(async () => {
  await getAssetCharts();
  await fetchCategoryTrend();
  await loadAssets();
  await loadAssetRequests();
  await loadAssetIssues();
  await seedCategory();
});
const date = (offDate) => {
  return monthDayYear.monthDayYear(offDate);
};

const deleteMaintenance = async (id) => {
  try {
    await ElMessageBox.confirm(
      "Are you sure you want to delete this record?",
      "Confirm delete",
      {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      }
    );
    await assetService.deleteMaintenance(id);
    ElNotification({ type: "success", message: "Deleted successfully" });
    getMaintenanceList();
  } catch (error) {
    console.error("Delete error:", error);
  }
};

const loadAssets = async () => {
  try {
    const response = await assetService.getAssets();
    assets.value = response; // Adjust mapping if backend structure differs
  } catch (error) {
    console.error("Error fetching assets:", error);
  }
};
const loadAssetIssues = async () => {
  try {
    const response = await assetService.getIssues();
    assetIssues.value = response; // Adjust mapping if backend structure differs
  } catch (error) {
    console.error("Error fetching assets:", error);
  }
};
const getMaintenanceList = async () => {
  try {
    loadingMaintenance.value = true;
    const response = await assetService.getMaintenance();
    maintenanceData.value = response || [];
  } catch (error) {
    console.error("Error fetching maintenance data:", error);
  } finally {
    loadingMaintenance.value = false;
  }
};
getMaintenanceList();

const loadAssetRequests = async () => {
  try {
    const response = await assetService.getRequests();
    assetsRequest.value = response; // Adjust mapping if needed
  } catch (error) {
    console.error("Error fetching asset requests:", error);
  }
};

const assetCategoryColChart = computed(() => {
  if (assetCategoryCol.value && assetCategoryCol.value.length === 0) return [];

  const colors = ["#0B55D4", "#111111"];

  // Return the transformed data
  return assetCategoryCol.value
    ? assetCategoryCol.value.map((item, index) => ({
        name: item.name,
        color: colors[index],
        data: item.data,
      }))
    : [];
});
const assetIssueColChart = computed(() => {
  if (assetIssueTrendCol.value && assetIssueTrendCol.value.length === 0) return [];

  const colors = ["#08A53D", "#111111"];

  // Return the transformed data
  return assetIssueTrendCol.value
    ? assetIssueTrendCol.value.map((item, index) => ({
        name: item.name,
        color: colors[index],
        data: item.data,
      }))
    : [];
});

// const handleSearchTextUpdate = (newValue) => {
//   searchText.value = newValue;
//   console.log(searchText.value, "hhahh");
// };
// const handleSearchTextUpdate2 = (newValue) => {
//   searchText.value = newValue;
//   console.log(searchText.value, "hhahh");
// };
</script>

<style scoped>
.border-radius-8 {
  border-radius: 8px;
}

.section-title {
  font-size: 20px;
  font-weight: 500;
  color: #1e1e1e !important;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.reset-btn {
  font-size: 16px;
  font-weight: 400;
}
.celeb-header {
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 20px;
  margin-top: 20px;
}
.celeb-icon {
  height: 81px;
  margin-left: -33px;
}
</style>
